import React from 'react';
import millify from 'millify';
import { ShelfTypeFilterEnum } from '@soundxyz/utils/constants/enums';
import { getSingularOrPlural } from '@utils/helpers';

export const getOwnershipStatusTooltipContent = ({
  serialNumber,
  finalQuantity,
  username,
  ownsMultipleNftsForRelease,
  numNFTsOwned,
}: {
  serialNumber?: number;
  finalQuantity: number | null | undefined;
  username: string;
  ownsMultipleNftsForRelease: boolean;
  numNFTsOwned: number;
}) => {
  const oneNFTTooltipContent = `${username} collected #${serialNumber}${
    finalQuantity ? `/${finalQuantity}` : ''
  }`;
  const multipleNFTsTooltipContent = `${username} collected #${serialNumber}${
    finalQuantity ? `/${finalQuantity}` : ''
  } and ${numNFTsOwned - 1} more`;

  return ownsMultipleNftsForRelease ? multipleNFTsTooltipContent : oneNFTTooltipContent;
};

export const PlaylistReleaseCountText = ({ releaseCount }: { releaseCount: number }) => {
  const songCountLabel = getSingularOrPlural({ count: releaseCount, word: 'sound' });

  return (
    <span data-testid="playlist-details">
      {millify(releaseCount)} {songCountLabel}
    </span>
  );
};

/**
 * Given an shelf input type filter return a boolean indicating if the playlist creator card should be shown
 */
export const shouldShowPlaylistCreator = (type: ShelfTypeFilterEnum) => {
  switch (type) {
    case ShelfTypeFilterEnum.ALL:
    case ShelfTypeFilterEnum.USER_CREATED:
      return true;
    default:
      return false;
  }
};

/**
 * Given an shelf input type filter return a boolean indicating if the playlist creator card should be shown
 */
export const shouldShowLikedSounds = (type: ShelfTypeFilterEnum) => {
  switch (type) {
    case ShelfTypeFilterEnum.ALL:
    case ShelfTypeFilterEnum.USER_CREATED:
      return true;
    default:
      return false;
  }
};

export const PLAYLISTS_COUNT = ({
  type,
  shelfCount,
  likedSound,
}: {
  type: ShelfTypeFilterEnum;
  shelfCount: number;
  likedSound: boolean;
}) => {
  /**
   * Liked sounds is a playlist we get from user entity and then append to list
   * So we need to add 1 to the count
   */
  if (shouldShowLikedSounds(type)) {
    return shelfCount + (likedSound ? 1 : 0);
  }

  return shelfCount;
};
